import React, { Component } from "react";
import { View, Image, TouchableOpacity, FlatList } from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, settingStyles } from '../theme/styles'
import TextView from "../components/TextView";
import LinearGradient from 'react-native-linear-gradient';
import { blueDarkColor, blueLightColor } from "../theme/colors";
import { orderListRequest, disagreeOrderRequest, acceptOrderRequest } from "../utils/api";
import Waiting from "../components/Waiting";
import { getError, showMessage } from "../utils/utils";
import RequestItem from "../components/RequestItem";

export default class RequestListScreen extends Component {
    _timerId = 0;
    constructor(props) {
        super(props)
        this.state = {
            waiting: true,
            orders_fav: [],
            orders: [],
        }
    }

    _keyExtractor = (item, index) => index.toString();
    renderRow({ item, index }) {
        return <RequestItem
            data={item}
            navigation={this.props.navigation}
            onDisagree={() => {
                this.setState({
                    waiting: true
                })
                disagreeOrderRequest(item.id, (isConnect, response) => {
                    if (isConnect && response.isSuccess) {
                        this.getData()
                    } else {
                        showMessage('', getError(response));
                    }
                })
            }}
            onAgree={() => {
                this.setState({
                    waiting: true
                })
                acceptOrderRequest(item.id, (isConnect, response) => {
                    if (isConnect && response.isSuccess) {
                        this.props.navigation.replace('orderInfo', {
                            data: item,
                            onRefresh: () => {

                            }
                        })
                    } else {
                        showMessage('', getError(response));
                    }

                })
            }} />
    }
    renderHeader() {
        if (this.state.orders_fav.length > 0) {
            return <View>
                <TextView style={{ textAlign: 'right', color: 'white', marginRight: 20, marginTop: 10 }}>سفارش های منتخب</TextView>
                <FlatList
                    data={this.state.orders_fav}
                    key={0}
                    renderItem={this.renderRow.bind(this)}
                    keyExtractor={this._keyExtractor} />
                {this.state.orders.length > 0 ? <TextView style={{ textAlign: 'right', color: 'white', marginRight: 20, marginTop: 10 }}>سایر سفارش ها</TextView> : null}
            </View>
        } else {
            return <View />
        }

    }
    render() {
        return (<View style={appStyles.flex1}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>لیست درخواست ها</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            <LinearGradient colors={[blueDarkColor, blueLightColor]} style={[settingStyles.wraper, { paddingTop: 5 }]}>
                <FlatList
                    data={this.state.orders}
                    key={1}
                    ListHeaderComponent={this.renderHeader.bind(this)}
                    renderItem={this.renderRow.bind(this)}
                    keyExtractor={this._keyExtractor} />
                <Waiting waiting={this.state.waiting} />
            </LinearGradient>

        </View>)
    }
    getData() {
        this.setState({
            waiting: true
        })
        orderListRequest((isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                this.setState({
                    orders: response.data.list_orders,
                    orders_fav: response.data.list_orders_fav
                })
            }
        })
    }

    componentWillMount() {
        this.getData()
        this.props.navigation.addListener(
            'didBlur',
            payload => {
                this._stopAutoPlay();
            })
        this.props.navigation.addListener(
            'didFocus',
            payload => {
                if (this._timerId) clearInterval(this._timerId)
                this._timerId = setInterval(() => this.getData(), 5000)
            }
        )
    }

    _stopAutoPlay() {
        if (this._timerId) {
            clearInterval(this._timerId)
            this._timerId = null
        }
    }
    componentWillUnmount() {
        this._stopAutoPlay()
    }
}